import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { siteMeta } from "@/mocks/manga";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/catalog", label: "阅读目录" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-heart-3-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950">
            {siteMeta.shortName}
            <span className="ml-1.5 text-xs font-medium text-primary-600">漫画网</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-100 font-semibold text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/catalog"
            className="ml-2 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            开始阅读
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 hover:bg-background-100 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `rounded-lg px-4 py-2.5 text-sm ${
                    isActive
                      ? "bg-primary-100 font-semibold text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/catalog"
              className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50"
            >
              开始阅读
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}